export default __webpack_public_path__ + "static/media/photo3.dcfe0d7a.jpg";